// Each student's end-of-session survey answer, as the backend recorded it,
// taken from the `end_of_session_survey` list on the session row.
//
// The raw enum is carried through unchanged; naming it is the renderer's job.
// A student who did not answer is absent from the response and stays absent
// here, so the report falls back rather than inventing a rating for them.
//
// The row keys students by id. The report identifies them by name, so the
// caller supplies the id -> name mapping it already holds — the same one the
// challenge rows carry, and the same join `pillsByName` does.

const EMPTY = {};

export const surveyByName = (students, nameById) => {
  if (!Array.isArray(students) || students.length === 0) return EMPTY;

  const byName = {};
  students.forEach(({ student_id: id, math_feel_rating: rating }) => {
    const name = nameById[id];
    if (!name) return;
    byName[name.toLowerCase()] = rating;
  });
  return byName;
};
